import classNames from 'classnames';

export const getThumbnailSize = (isPortrait?: boolean, isBig?: boolean) => {
  return {
    thumbWidth: classNames({
      'w-[var(--upload-el-width)]': isBig && !isPortrait,
      'w-[var(--thumbnail-width)]': !isBig && !isPortrait,
      'w-[var(--upload-el-width-portrait)]': isBig && isPortrait,
      'w-[var(--thumbnail-width-portrait)]': !isBig && isPortrait,
    }),
    thumbAspect: classNames({
      'aspect-video': !isPortrait,
      'aspect-[9/16]': isPortrait,
    }),
  };
};

export const getVideoName = (videoName: string, isSubClip?: boolean) => {
  const [baseName, ext = ''] = videoName.split(/\.(?=[^.]+$)/);
  const extWithDot = ext ? `.${ext}` : '';
  const name = baseName.split('@')[0];
  return (isSubClip ? 'From ' : '') + name + extWithDot;
};
